{
    "name": "@verbleif/shared",
    "type": "module",
    "version": "6.0.0",
    "private": true,
    "description": "",
    "author": "Verbleif",
    "license": "MIT",
    "exports": {
        "./package.json": "./package.json",
        "./src/*.vue": "./src/*.vue",
        "./src/*.vue?vue": "./src/*.vue",
        "./src/*.vue?raw": "./src/*.vue",
        "./src/*.css": "./src/*.css",
        "./src/*.css?raw": "./src/*.css",
        "./src/*.css?inline": "./src/*.css",
        "./src/*.scss": "./src/*.scss",
        "./src/*.scss?raw": "./src/*.scss",
        "./src/*.scss?inline": "./src/*.scss",
        "./src/*.json": "./src/*.json",
        "./src/*.json?raw": "./src/*.json",
        "./src/*.svg": "./src/*.svg",
        "./src/*.svg?component": "./src/*.svg",
        "./src/*.svg?url": "./src/*.svg",
        "./src/*.svg?raw": "./src/*.svg",
        "./src/*.png": "./src/*.png",
        "./src/*.png?url": "./src/*.png",
        "./src/*.png?raw": "./src/*.png",
        "./src/*.jpg": "./src/*.jpg",
        "./src/*.jpg?url": "./src/*.jpg",
        "./src/*.jpg?raw": "./src/*.jpg",
        "./src/*.jpeg": "./src/*.jpeg",
        "./src/*.jpeg?url": "./src/*.jpeg",
        "./src/*.jpeg?raw": "./src/*.jpeg",
        "./src/*.gif": "./src/*.gif",
        "./src/*.gif?url": "./src/*.gif",
        "./src/*.gif?raw": "./src/*.gif",
        "./src/*.webp": "./src/*.webp",
        "./src/*.webp?url": "./src/*.webp",
        "./src/*.webp?raw": "./src/*.webp",
        "./src/*.woff": "./src/*.woff",
        "./src/*.woff2": "./src/*.woff2",
        "./src/*.js": "./src/*.ts",
        "./src/*.ts?worker": "./src/*.ts",
        "./src/*.js?worker": "./src/*.ts",
        "./src/*": "./src/*.ts"
    },
    "scripts": {
        "analyse": "yarn vite-bundle-visualizer",
        "lint": "eslint .",
        "lint:fix": "eslint . --fix",
        "typecheck": "vue-tsc --noEmit"
    },
    "dependencies": {
        "@atlaskit/pragmatic-drag-and-drop": "^3.1.0",
        "@atlaskit/pragmatic-drag-and-drop-auto-scroll": "^3.2.0",
        "@atlaskit/pragmatic-drag-and-drop-hitbox": "^2.2.2",
        "@tanstack/vue-query": "^5.103.2",
        "@tanstack/vue-virtual": "^3.13.39",
        "@types/diff-match-patch": "^1.0.36",
        "@verbleif/lib": "*",
        "@vueuse/components": "^15.0.0",
        "@vueuse/core": "^15.0.0",
        "@vueuse/router": "^15.0.0",
        "axios": "^1.20.0",
        "crypto-es": "^3.1.3",
        "diff-match-patch": "^1.0.5",
        "driver.js": "^1.8.0",
        "lodash": "^4.18.1",
        "vee-validate": "^4.15.1",
        "vue": "3.5.43",
        "vue-i18n": "^11.4.12",
        "vue-router": "^5.3.1",
        "vue-sonner": "^2.0.9",
        "xlsx": "^0.18.5",
        "xlsx-js-style": "^1.2.0"
    },
    "devDependencies": {
        "@sentry/vite-plugin": "^5.4.0",
        "@vitejs/plugin-react": "^6.1.1",
        "@vitejs/plugin-vue": "^6.0.9",
        "@vitejs/plugin-vue-jsx": "^5.1.6",
        "concurrently": "^10.0.5",
        "dotenv": "^18.0.2",
        "eslint": "^10.11.0",
        "jsdom": "^30.1.1",
        "rollup-plugin-visualizer": "^7.1.1",
        "sass": "^1.104.1",
        "sort-package-json": "^4.0.0",
        "terser": "^5.51.2",
        "typescript": "6.0.3",
        "unplugin-auto-import": "^21.1.0",
        "unplugin-vue-components": "^32.1.0",
        "vite": "^8.3.0",
        "vite-bundle-visualizer": "^1.2.1",
        "vite-plugin-eslint2": "^5.3.0",
        "vite-plugin-inspect": "^12.0.2",
        "vite-plugin-istanbul": "^9.0.1",
        "vite-svg-loader": "^5.1.3",
        "vite-tsconfig-paths": "^6.1.1",
        "vue-tsc": "3.3.11"
    },
    "browserslist": [
        "> 1%",
        "last 2 versions",
        "not dead",
        "chrome > 40",
        "not ie 11"
    ],
    "lint-staged": {
        "*.{js,ts,vue}": "eslint .",
        "package.json": "sort-package-json"
    }
}
